import { negate } from 'lodash-es';
import { PermissionCheck } from '../types';
import { createPermission } from './createPermission';

export function createNegateVariants<T extends Record<string, PermissionCheck>>(
  permissions: T
) {
  return Object.entries(permissions).reduce(
    (acc, [k, v]) => ({ ...acc, [k]: createPermission(negate(v)) }),
    {} as T
  );
}
